export default __webpack_public_path__ + "static/media/gude-2022-08-23.b70363b8.log";